import axios from "axios";
import VueAxios from "vue-axios";
export default {
  install(Vue) {
    // axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "http://127.0.0.1:8000/api";

    const API_BASE = 'https://lk-api.actid.ru'//process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_API_BASE || "/api"
    var instance = axios.create({
      baseURL: API_BASE,
      timeout: 10000,
    });

    Vue.use(VueAxios, instance);
    Vue.axios.defaults.baseURL = API_BASE
  }
};
